// extracted by mini-css-extract-plugin
export var container = "Feature-module--container--PHk3l";
export var content = "Feature-module--content--VNann";
export var grid = "Feature-module--grid--p9pnQ";
export var header = "Feature-module--header---JB+j";
export var headline = "Feature-module--headline--qzoBV";
export var overlapPreviousComponent = "Feature-module--overlap-previous-component--TV5gk";
export var subheadline = "Feature-module--subheadline--eGjWI";
export var tagline = "Feature-module--tagline--Nj84A";
export var wrapper = "Feature-module--wrapper--3BPvf";